import * as React from 'react';
import './plans.module.scss';
import { MembershipPlanIndexView, MembershipPlanKey } from '../../../types/membershipPlans';
import { MembershipPlanId } from '../../../../commonv3/types/membershipPlans';
import { observer } from 'mobx-react';
import { MainTab, MainTabList } from '../navigation/MainTab';

type SelectorProps = {
  plans: MembershipPlanIndexView[];
  selectedPlanId: MembershipPlanId;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  onPlanChange: (planId: MembershipPlanId) => any;
};

export const PlanSelector = observer(({ selectedPlanId, onPlanChange, plans }: SelectorProps) => {
  const casualPlan = plans.find((p) => p.key === MembershipPlanKey.CASUAL);
  const regularPlan = plans.find((p) => p.key === MembershipPlanKey.REGULAR);
  return (
    <MainTabList styleName="plan-selector">
      {regularPlan && (
        <MainTab
          id="regular-tab"
          iconName={'trending_up'}
          title={regularPlan.name}
          selected={selectedPlanId === regularPlan.id}
          onSelect={() => onPlanChange(regularPlan.id)}
        />
      )}
      {casualPlan && (
        <MainTab
          id="casual-tab"
          iconName={'local_play'}
          title={casualPlan.name}
          selected={selectedPlanId === casualPlan.id}
          onSelect={() => onPlanChange(casualPlan.id)}
        />
      )}
    </MainTabList>
  );
});
